<div class="modal-header">
	<h5 class="modal-title">
		<i class="bi" [class.bi-palette]="!isGpkgAttributesOnly" [class.bi-table]="isGpkgAttributesOnly" class="me-2"></i>{{ title }}
	</h5>
	<button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
</div>
<div class="modal-body" [class.gpkg-modal-body]="isGpkgMode" [class.gpkg-attributes-only-body]="isGpkgAttributesOnly">
	<!-- Nur Attribute anzeigen (Karten-Klick) -->
	<div class="gpkg-attributes-only" *ngIf="isGpkgAttributesOnly; else fullMode">
		<div class="attributes-table-container">
			<table class="attributes-table">
				<tbody>
					<tr *ngFor="let key of attributeKeys">
						<td class="attr-key">{{ key }}</td>
						<td class="attr-value">{{ gpkgAttributes ? gpkgAttributes[key] ?? '–' : '–' }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>

	<ng-template #fullMode>
	<div class="gpkg-container" *ngIf="isGpkgMode; else normalMode">
		<!-- GPKG-Modus: Style links, Attribute rechts -->
		<div class="gpkg-style-panel">
			<!-- Vorschau -->
			<div class="preview-section mb-3">
				<label class="section-label">Vorschau</label>
				<div class="preview-box">
					<svg width="100%" height="50" viewBox="0 0 200 50">
						<polygon points="20,45 50,10 80,45"
							[attr.stroke]="style.strokeColor"
							[attr.stroke-width]="style.strokeWidth"
							[attr.fill]="style.fillColor"
							[attr.fill-opacity]="style.fillOpacity"
						/>
						<polyline points="100,40 130,15 160,35 190,10"
							[attr.stroke]="style.strokeColor"
							[attr.stroke-width]="style.strokeWidth"
							fill="none"
						/>
					</svg>
				</div>
			</div>

			<!-- Linien-/Randfarbe -->
			<div class="style-section mb-2">
				<label class="section-label">Linienfarbe</label>
				<div class="color-palette compact">
					<div *ngFor="let color of colorPalette"
						class="color-swatch"
						[style.background-color]="color"
						[class.selected]="style.strokeColor === color"
						(click)="onStrokeColorChange(color)">
					</div>
				</div>
			</div>

			<!-- Linienstärke -->
			<div class="style-section mb-2">
				<label class="section-label">Linienstärke</label>
				<div class="width-options compact">
					<button *ngFor="let width of strokeWidths"
						class="width-option"
						[class.selected]="style.strokeWidth === width"
						(click)="onStrokeWidthChange(width)">
						{{width}}px
					</button>
				</div>
			</div>

			<!-- Flächenfarbe -->
			<div class="style-section mb-2">
				<label class="section-label">Flächenfarbe</label>
				<div class="color-palette compact">
					<div *ngFor="let color of colorPalette"
						class="color-swatch"
						[style.background-color]="color"
						[class.selected]="style.fillColor === color"
						(click)="onFillColorChange(color)">
					</div>
				</div>
			</div>

			<!-- Flächendeckung -->
			<div class="style-section mb-2">
				<label class="section-label">Flächendeckung</label>
				<div class="opacity-options compact">
					<button *ngFor="let opacity of fillOpacities"
						class="opacity-option"
						[class.selected]="style.fillOpacity === opacity"
						(click)="onFillOpacityChange(opacity)"
						[title]="formatOpacity(opacity)">
						<div class="opacity-preview"
							[style.background-color]="style.fillColor"
							[style.opacity]="opacity">
						</div>
					</button>
				</div>
			</div>
		</div>
	</div>

	<ng-template #normalMode>
		<!-- Normaler Modus: Wie bisher -->
		<!-- Vorschau -->
		<div class="preview-section mb-4">
			<label class="section-label">Vorschau</label>
			<div class="preview-box">
				<svg width="100%" height="60" viewBox="0 0 200 60">
					<!-- Polygon-Vorschau (nur für Polygone) -->
					<polygon *ngIf="!isLineStyle"
						points="20,50 50,10 80,50"
						[attr.stroke]="style.strokeColor"
						[attr.stroke-width]="style.strokeWidth"
						[attr.fill]="style.fillColor"
						[attr.fill-opacity]="style.fillOpacity"
					/>
					<!-- Linien-Vorschau -->
					<polyline
						[attr.points]="isLineStyle ? '20,45 60,15 100,35 140,10 180,30' : '100,45 130,15 160,35 190,10'"
						[attr.stroke]="style.strokeColor"
						[attr.stroke-width]="style.strokeWidth"
						fill="none"
					/>
				</svg>
			</div>
		</div>

		<!-- Linien-/Randfarbe -->
		<div class="style-section mb-3">
			<label class="section-label">{{ isLineStyle ? 'Linienfarbe' : 'Linien- / Randfarbe' }}</label>
			<div class="color-palette">
				<div *ngFor="let color of colorPalette"
					class="color-swatch"
					[style.background-color]="color"
					[class.selected]="style.strokeColor === color"
					(click)="onStrokeColorChange(color)"
					[title]="color">
				</div>
			</div>
		</div>

		<!-- Linienstärke -->
		<div class="style-section mb-3">
			<label class="section-label">Linienstärke</label>
			<div class="width-options">
				<button *ngFor="let width of strokeWidths"
					class="width-option"
					[class.selected]="style.strokeWidth === width"
					(click)="onStrokeWidthChange(width)">
					<svg width="40" height="20" viewBox="0 0 40 20">
						<line x1="5" y1="10" x2="35" y2="10"
							[attr.stroke]="style.strokeColor"
							[attr.stroke-width]="width"/>
					</svg>
					<span class="width-label">{{width}}px</span>
				</button>
			</div>
		</div>

		<!-- Flächenfarbe (nur für Polygone) -->
		<div class="style-section mb-3" *ngIf="!isLineStyle">
			<label class="section-label">Flächenfarbe</label>
			<div class="color-palette">
				<div *ngFor="let color of colorPalette"
					class="color-swatch"
					[style.background-color]="color"
					[class.selected]="style.fillColor === color"
					(click)="onFillColorChange(color)"
					[title]="color">
				</div>
			</div>
		</div>

		<!-- Flächendeckung (nur für Polygone) -->
		<div class="style-section mb-3" *ngIf="!isLineStyle">
			<label class="section-label">Flächendeckung</label>
			<div class="opacity-options">
				<button *ngFor="let opacity of fillOpacities"
					class="opacity-option"
					[class.selected]="style.fillOpacity === opacity"
					(click)="onFillOpacityChange(opacity)">
					<div class="opacity-preview"
						[style.background-color]="style.fillColor"
						[style.opacity]="opacity">
					</div>
					<span class="opacity-label">{{formatOpacity(opacity)}}</span>
				</button>
			</div>
		</div>
	</ng-template>
	</ng-template>
</div>
<div class="modal-footer" *ngIf="!isGpkgAttributesOnly">
	<button type="button" class="btn btn-link btn-sm text-muted" (click)="onReset()">Zurücksetzen</button>
	<button type="button" class="btn btn-outline-secondary btn-sm" (click)="onCancel()">Abbrechen</button>
	<button type="button" class="btn btn-primary btn-sm" (click)="onSave()">Übernehmen</button>
</div>
<div class="modal-footer" *ngIf="isGpkgAttributesOnly">
	<button type="button" class="btn btn-outline-secondary btn-sm" (click)="onCancel()">Schließen</button>
</div>
